<template>
    <div>
        <consultorias
            :consultorias="consultorias"
            :solicitacoes="false"
            :fornecedor="false"
            titulo="APP SEBRAE - CONSULTORIAS"
            v-show="mostrarConsultorias"
            @atualizar-listagem="obterConsultorias()"
        >
            <template slot="acoes" slot-scope="data">
                <span
                    class="text-primary"
                    v-if="$temAcessoView('APPSE-UABS-CONS-00')"
                >
                    <i
                        class="fa fa-info-circle fa-lg icon-button"
                        title="Detalhar"
                        @click.stop="detalhar(data.consultoriaId)"
                    ></i>
                </span>
            </template>
        </consultorias>
        <router-view></router-view>
    </div>
</template>

<script>
import ConsultoriasServicos from './ConsultoriasServicos'
import Consultorias from '../../componentes/consultorias/Consultorias'

export default {
    data() {
        return {
            consultorias: []
        }
    },
    methods: {
        obterConsultorias() {
            this.$store.dispatch('addRequest')
            ConsultoriasServicos.obterTodasConsultorias().then(response => {
                if (response) {
                    if (response.success) {
                        this.consultorias = response.data
                    } else {
                        this.$toast.error(
                            response.errors[0],
                            'ERROR',
                            this.$toastConfig.error
                        )
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        },

        detalhar(consultoriaId) {
            this.$router.push({
                name: 'AppSebrae_Consultorias_Uabs_Consultorias_Detalhar',
                params: {
                    consultoriaId: consultoriaId
                }
            })
        }
    },

    created() {
        this.obterConsultorias()
    },

    computed: {
        mostrarConsultorias() {
            return (
                this.$route.name === 'AppSebrae_Consultorias_Uabs_Consultorias'
            )
        }
    },

    components: {
        Consultorias
    },

    watch: {
        $route(to) {
            if (to.name === 'AppSebrae_Consultorias_Fornecedor_Consultorias') {
                if (this.$store.getters.recarregar) {
                    this.obterConsultorias()
                    this.$store.dispatch('setRecarregar', false)
                }
            }
        }
    }
}
</script>
